import { observer } from 'mobx-react'
import { LegalText } from 'components/DigitalAccountCheck/IntroText/LegalText'
import useStore from 'stores/utils/hooks/useStore'
import { TrustCards } from './TrustCards'
import { getFooterSeals } from 'components/Footer/getSeals'
import Seals from 'components/Footer/Seals'

const DacFooterWrapper = observer(
  ({ isFfgDacWrapper }: { isFfgDacWrapper: boolean }) => {
    const {
      traversalSession: { dacWidgetStep },
      navigation: { isDacPage }
    } = useStore()

    return (
      <>
        {isFfgDacWrapper ? (
          <Seals seals={getFooterSeals()} itemMargin={16} />
        ) : (
          <>
            <TrustCards />
          </>
        )}
        {isDacPage && dacWidgetStep === 'BANK_LOGIN_STEP' && <LegalText />}
      </>
    )
  }
)

export { DacFooterWrapper }
